"use client";

import PowerDialer from "../../../components/PowerDialer";

export default function PowerDialerPage() {
  return <PowerDialer />;
}
